export default "__VITE_ASSET__DBtu6v9u__"